import create from "zustand"

const getSessionItem = (key, fallback) => {
  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : fallback;
  } catch (e) {
    return fallback;
  }
};

const useStore = create(set => ({
    mobileNo: {},
    allQuestionData: getSessionItem("ekyc_all_question_data", []),
    outlet: getSessionItem("ekyc_outlet", {}),
    userDetailsData:{},
    fetchMobileNo: data => {
      set({ mobileNo: data })
    },
    setOutletDataInStore: ({ outletId, storeData}) => set({
      [outletId]: storeData
    }),
    getOutletData: ({ outletId }) => set(),
    fetchAllQuestionData:(data)=>{
      try {
        sessionStorage.setItem("ekyc_all_question_data", JSON.stringify(data || []));
      } catch (e) {}
      set({allQuestionData:data})
    },
    fetchOutlet: data => {
      try {
        sessionStorage.setItem("ekyc_outlet", JSON.stringify(data || {}));
      } catch (e) {}
      set({ outlet: data })
    },
    fetchUserDetails:data => {
      set({userDetailsData:data})
    }
  }))

  export default useStore

